import { Loader2 } from "lucide-react";

interface LoadingSpinnerProps {
  fullScreen?: boolean;
  className?: string;
}

export function LoadingSpinner({ fullScreen = false, className }: LoadingSpinnerProps) {
  const wrapper = fullScreen
    ? "flex min-h-screen items-center justify-center bg-background"
    : "flex items-center justify-center p-8";
  return (
    <div className={`${wrapper} ${className ?? ""}`}>
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
}
